var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "carousel-splide"
  }, [_c('splide', {
    attrs: {
      "options": _vm.options
    }
  }, _vm._l(_vm.slides, function (item, index) {
    return _c('splide-slide', {
      key: index
    }, [_vm._t("content", null, {
      "item": item,
      "index": index
    })], 2);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }